import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  transition: transform 0.3s ease-in-out;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import IconDefault from './IconDefault';
import IconWrapper from './components/IconWrapper';
var StyledIconDefault = styled(IconDefault)(_templateObject(), function (_ref) {
  var $rotated = _ref.$rotated,
      $direction = _ref.$direction;
  return $rotated && "\n    transform: rotate(" + ($direction === 'inverse' ? '-180deg' : '180deg') + ");\n  ";
});

var IconWithRotation = function IconWithRotation(_ref2) {
  var _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? 'default' : _ref2$direction,
      _ref2$flex = _ref2.flex,
      flex = _ref2$flex === void 0 ? true : _ref2$flex,
      _ref2$pointer = _ref2.pointer,
      pointer = _ref2$pointer === void 0 ? false : _ref2$pointer,
      _ref2$rotated = _ref2.rotated,
      rotated = _ref2$rotated === void 0 ? false : _ref2$rotated,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$inactive = _ref2.inactive,
      inactive = _ref2$inactive === void 0 ? false : _ref2$inactive,
      _ref2$hasArrow = _ref2.hasArrow,
      hasArrow = _ref2$hasArrow === void 0 ? false : _ref2$hasArrow,
      _ref2$hasClose = _ref2.hasClose,
      hasClose = _ref2$hasClose === void 0 ? false : _ref2$hasClose,
      icon = _ref2.icon,
      color = _ref2.color,
      colorHover = _ref2.colorHover,
      _ref2$arrow = _ref2.arrow,
      arrow = _ref2$arrow === void 0 ? 'right' : _ref2$arrow,
      className = _ref2.className,
      style = _ref2.style,
      props = _objectWithoutPropertiesLoose(_ref2, ["direction", "flex", "pointer", "rotated", "disabled", "inactive", "hasArrow", "hasClose", "icon", "color", "colorHover", "arrow", "className", "style"]);

  return /*#__PURE__*/React.createElement(IconWrapper, {
    flex: flex,
    pointer: pointer,
    disabled: disabled,
    inactive: inactive,
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(StyledIconDefault, _extends({
    $direction: direction,
    $rotated: rotated,
    pointer: pointer,
    disabled: disabled,
    inactive: inactive,
    hasArrow: hasArrow,
    hasClose: hasClose,
    icon: icon,
    color: color,
    colorHover: colorHover,
    arrow: arrow,
    flex: flex
  }, props)));
};

export default IconWithRotation;